//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/CommonServices";
import * as OM from "@/model";
import { apiurl } from '@/config';

class _LoginClient {

    

                
            adminLogin(
                psw:string,showSpinner = true): Promise<OM.LoginResponse> {
                        return CommonServices.defaultGet<OM.LoginResponse>(apiurl + 'api/Login/AdminLogin',{ psw }, showSpinner);

                    }
    

                
            loginFromGuid(
                identifier:string,showSpinner = true): Promise<OM.LoginResponse> {
                        return CommonServices.defaultGet<OM.LoginResponse>(apiurl + 'api/Login/LoginFromGuid',{ identifier }, showSpinner);

                    }
    

                
            loginFromOnOffice(
                userId:string,
                customerWebId:string,
                apiClaim:string,showSpinner = true): Promise<OM.LoginResponse> {
                        return CommonServices.defaultGet<OM.LoginResponse>(apiurl + 'api/Login/LoginFromOnOffice',{ userId, customerWebId, apiClaim }, showSpinner);

                    }
    

                
            refreshLogin(showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Login/RefreshLogin',{  }, showSpinner);

                    }
    }

export let LoginClient = new _LoginClient();

class _MarketplaceClient {

    

                
            checkSignature(
                message:string,
                signature:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Marketplace/CheckSignature',{ message, signature }, showSpinner);

                    }
    

                
            getSignature(
                message:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Marketplace/GetSignature',{ message }, showSpinner);

                    }
    

                
            activateMarketplace(
                userSecretKey:string,
                apiToken:string,
                apiClaim:string,
                parameterCacheId:string,
                userId:string,
                customerWebId:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Marketplace/ActivateMarketplace',{ userSecretKey, apiToken, apiClaim, parameterCacheId, userId, customerWebId }, showSpinner);

                    }
    

                
            checkActivation(
                customerWebId:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Marketplace/CheckActivation',{ customerWebId }, showSpinner);

                    }
    

                
            updateApiClaim(
                webUserId:string,
                newApiClaim:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Marketplace/UpdateApiClaim',{ webUserId, newApiClaim }, showSpinner);

                    }
    }

export let MarketplaceClient = new _MarketplaceClient();

class _OnOfficeClient {

    

                
            getPagedEstates(
                vm:OM.SearchEstatePagedVm,showSpinner = true): Promise<OM.OnOfficePagedResponseOfOnOfficePagedEstateRow> {
                        return CommonServices.defaultPost<OM.OnOfficePagedResponseOfOnOfficePagedEstateRow>(apiurl + 'api/OnOffice/GetPagedEstates', vm,{}, showSpinner );

                    }
    

                
            getEstateValues(
                vm:OM.GetEstateValuesVm,showSpinner = true): Promise<{ [key: string]: string; }> {
                        return CommonServices.defaultPost<{ [key: string]: string; }>(apiurl + 'api/OnOffice/GetEstateValues', vm,{}, showSpinner );

                    }
    

                
            getEstatePhotos(
                vm:OM.GetEstateValuesVm,showSpinner = true): Promise<OM.GetEstateFilesResponse[]> {
                        return CommonServices.defaultPost<OM.GetEstateFilesResponse[]>(apiurl + 'api/OnOffice/GetEstatePhotos', vm,{}, showSpinner );

                    }
    }

export let OnOfficeClient = new _OnOfficeClient();

class _OnOfficeFieldDefinitionClient {

    

                
            getEstateFields(
                vm:OM.OnOfficeFieldDefinitionListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfOnOfficeFieldDefinition> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfOnOfficeFieldDefinition>(apiurl + 'api/OnOfficeFieldDefinition/GetEstateFields', vm,{}, showSpinner );

                    }
    }

export let OnOfficeFieldDefinitionClient = new _OnOfficeFieldDefinitionClient();

class _PrintedPdfClient {

    

                
            getByFilter(
                vm:OM.PrintedPdfListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfPrintedPdf> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfPrintedPdf>(apiurl + 'api/PrintedPdf/GetByFilter', vm,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.PrintedPdf> {
                        return CommonServices.defaultGet<OM.PrintedPdf>(apiurl + 'api/PrintedPdf/GetById',{ identifier }, showSpinner);

                    }
    

                
            generate(
                printProjectIdentifier:string,showSpinner = true): Promise<OM.PrintedPdf> {
                        return CommonServices.defaultGet<OM.PrintedPdf>(apiurl + 'api/PrintedPdf/Generate',{ printProjectIdentifier }, showSpinner);

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PrintedPdf/DeleteById',{ identifier }, showSpinner);

                    }
    }

export let PrintedPdfClient = new _PrintedPdfClient();

class _PrintProjectClient {

    

                
            getByFilter(
                vm:OM.PrintProjectListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfPrintProject> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfPrintProject>(apiurl + 'api/PrintProject/GetByFilter', vm,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.PrintProject> {
                        return CommonServices.defaultGet<OM.PrintProject>(apiurl + 'api/PrintProject/GetById',{ identifier }, showSpinner);

                    }
    

                
            create(
                templateIdentifier:string,showSpinner = true): Promise<OM.PrintProject> {
                        return CommonServices.defaultGet<OM.PrintProject>(apiurl + 'api/PrintProject/Create',{ templateIdentifier }, showSpinner);

                    }
    

                
            save(
                item:OM.PrintProject,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/PrintProject/Save', item,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PrintProject/DeleteById',{ identifier }, showSpinner);

                    }
    }

export let PrintProjectClient = new _PrintProjectClient();

class _PrintTemplateClient {

    

                
            getByFilter(
                vm:OM.PrintTemplateListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfPrintTemplate> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfPrintTemplate>(apiurl + 'api/PrintTemplate/GetByFilter', vm,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.PrintTemplate> {
                        return CommonServices.defaultGet<OM.PrintTemplate>(apiurl + 'api/PrintTemplate/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.PrintTemplate,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/PrintTemplate/Save', item,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/PrintTemplate/DeleteById',{ identifier }, showSpinner);

                    }
    }

export let PrintTemplateClient = new _PrintTemplateClient();

class _RecentEstatesClient {

    

                
            getMine(showSpinner = true): Promise<OM.EstateSelection[]> {
                        return CommonServices.defaultGet<OM.EstateSelection[]>(apiurl + 'api/RecentEstates/GetMine',{  }, showSpinner);

                    }
    

                
            add(
                item:OM.EstateSelection,showSpinner = true): Promise<OM.EstateSelection[]> {
                        return CommonServices.defaultPost<OM.EstateSelection[]>(apiurl + 'api/RecentEstates/Add', item,{}, showSpinner );

                    }
    }

export let RecentEstatesClient = new _RecentEstatesClient();

class _UserActivationClient {

    

                
            getByFilter(
                vm:OM.UserActivationListFilterVm,showSpinner = true): Promise<OM.TablePagedResultOfUserActivation> {
                        return CommonServices.defaultPost<OM.TablePagedResultOfUserActivation>(apiurl + 'api/UserActivation/GetByFilter', vm,{}, showSpinner );

                    }
    

                
            getById(
                identifier:string,showSpinner = true): Promise<OM.UserActivation> {
                        return CommonServices.defaultGet<OM.UserActivation>(apiurl + 'api/UserActivation/GetById',{ identifier }, showSpinner);

                    }
    

                
            save(
                item:OM.UserActivation,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/UserActivation/Save', item,{}, showSpinner );

                    }
    

                
            deleteById(
                identifier:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/UserActivation/DeleteById',{ identifier }, showSpinner);

                    }
    }

export let UserActivationClient = new _UserActivationClient();

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}